<template>
  <div id="Wrapper">
    <Header
      :siteInfo="siteInfo"
    />
    <div class="main_container">
      <Sidebar
        :siteInfo="siteInfo"
      />
      <SettingCamListsComponent
        v-if="siteInfo !== null && cameraInfo !== null"
        :siteInfo="siteInfo"
        :cameraInfo="cameraInfo"
        @loadStart="loadStart"
        @loadFinish="loadFinish"
      />
    </div>
  </div>
</template>
<script>
import Header from '../../components/header/Header'
import Sidebar from '../../components/sidebar/Sidebar'
import SettingCamListsComponent from '../../components/main/SettingCamListsComponent'

export default {
  name: 'SettingCamLists',
  data: function(){
    return {
    }
  },
  props:{
    siteInfo:{
      type: Array
    },
    cameraInfo:{
      type: Array
    },
  },
  methods: {
    loadStart() {
      this.$emit('loadStart');
    },
    loadFinish() {
      this.$emit('loadFinish');
    },
  },
  components:{
    Header,
    Sidebar,
    SettingCamListsComponent
  },
}
</script>
<style lang="scss">
</style>